import React, { useState } from 'react';

import { useDispatch } from 'react-redux';

import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Input from '@amzn/meridian/input';
import Row from '@amzn/meridian/row';
import SearchField from '@amzn/meridian/search-field';
import Text from '@amzn/meridian/text';
import Tooltip from '@amzn/meridian/tooltip';
import { useAppSelector } from 'src/store/store';
import { setSiteCapacityFormData } from 'src/store/updateSiteCapacitySlice/updateSiteCapacitySlice';
import { createSearchRegExp } from 'src/utils/searchUtils';

const ShiftList = ({ isShiftActive }: { isShiftActive: boolean }) => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState('');
  const { siteCapacityFormData, siteCapacityFormErrors } = useAppSelector((state) => state.updateSiteCapacityPage);
  const searchRegExp = createSearchRegExp(searchValue);

  if (siteCapacityFormData?.shifts?.length === 0) {
    return <NoResults />;
  }

  const matchedShifts = siteCapacityFormData?.shifts?.filter((shift) => searchRegExp.test(shift?.shiftCode));

  return (
    <Column type="outline" spacingInset="400">
      <SearchField
        disabled={!isShiftActive}
        value={searchValue}
        onChange={setSearchValue}
        onSubmit={() => {}}
        placeholder="Search for shift"
      />
      {matchedShifts?.length === 0 ? (
        <NoResults />
      ) : (
        <Column spacingInset="300" spacing="300" overflowY="scroll" maxHeight="210px">
          {matchedShifts?.map((shift) => (
            <Box key={shift.id}>
              <Row spacing="200">
                <Text>{shift?.shiftCode}</Text>
                {!!shift && shift.isActive === false && (
                  <Tooltip position="end" title="Shift will not be included in job matching results">
                    <Row spacing="200">
                      <Text color="error">(Inactive)</Text>
                      <Icon color="error" tokens={infoKnockoutTokens} />
                    </Row>
                  </Tooltip>
                )}
              </Row>
              <Input
                disabled={!isShiftActive}
                error={siteCapacityFormErrors?.shifts[shift?.shiftCode]?.error}
                errorMessage={siteCapacityFormErrors?.shifts[shift?.shiftCode]?.errorMessage}
                placeholder="Select slot"
                value={shift?.slots?.toString()}
                onChange={(slots) => {
                  dispatch(
                    setSiteCapacityFormData({
                      ...siteCapacityFormData,
                      shifts: siteCapacityFormData?.shifts?.map((s) =>
                        s?.shiftCode === shift?.shiftCode ? { ...s, slots } : s,
                      ),
                    }),
                  );
                }}
                suffix="Slots"
              />
            </Box>
          ))}
        </Column>
      )}
    </Column>
  );
};

const NoResults = () => (
  <Box type="fill" spacingInset="400">
    <Text alignment="center" color="secondary">
      No results
    </Text>
  </Box>
);

export default ShiftList;
